<template>
  <div class="c metrics-parking-table">
    <v-data-table
      :headers="headers"
      :items="formattedParkingEvents"
    >
      <template slot="items" slot-scope="event">
        <td>{{ event.item.event_started }}</td>
        <td>{{ event.item.event_ended }}</td>
        <td>{{ event.item.duration }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'parking-table',

  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  computed: {
    formattedParkingEvents() {
      var formatDate = function(date) {
        return date.isValid() ? moment.utc(date).local().format('llll') : "-"
      }
      return this.data.map((event) => {
        var eventStarted = moment.utc(event.event_started);
        var eventEnded = moment.utc(event.event_ended);
        var durationSinceEventEnded = eventEnded.isValid() ? eventEnded : moment()
        var duration = moment.utc(moment.duration(durationSinceEventEnded.diff(eventStarted)).asMilliseconds())

        return {
          event_started: formatDate(eventStarted),
          event_ended: formatDate(eventEnded),
          duration: duration.format('HH:mm'),
        };
      });
    }
  },

  data() {
    return {
      headers: [
        {
          text: 'Start',
          align: 'left',
          sortable: false,
          value: 'event_started',
        },
        { text: 'Ende', sortable: false, value: 'event_ended' },
        { text: 'Dauer', sortable: false, value: 'duration' },
      ]
    };
  },
};
</script>
